// @flow

import { selectTaxesDisplaySetting } from '@gandi/authentication';

import type { FullState } from 'src/types';

export const selectCorporatePackMonthlyPrice = (
  state: FullState,
): void | number => {
  const taxesIncluded = selectTaxesDisplaySetting(state);
  return taxesIncluded
    ? state.app.corporatePackMonthlyPrice.priceAfterTaxes
    : state.app.corporatePackMonthlyPrice.priceBeforeTaxes;
};

export const selectCorporatePackMonthlyCurrency = (
  state: FullState,
): void | string => state.app.corporatePackMonthlyPrice.currency;
